import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Enterprise6SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M7.656.81a7 7 0 0 0-7 7v3h2.25a2 2 0 0 0 2-2v-.75a2 2 0 0 0-2-2h-.465a5.502 5.502 0 0 1 10.431 0h-.466a2 2 0 0 0-2 2v.75a2 2 0 0 0 2 2h.75a2.5 2.5 0 0 1-2.5 2.5h-1v-.5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a4 4 0 0 0 4-4v-3a7 7 0 0 0-7-7Zm4.75 6.75h.745c.003.083.005.167.005.25v1.5h-.75a.5.5 0 0 1-.5-.5v-.75a.5.5 0 0 1 .5-.5Zm-10.244 0a5.59 5.59 0 0 0-.006.25v1.5h.75a.5.5 0 0 0 .5-.5v-.75a.5.5 0 0 0-.5-.5h-.744Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Enterprise6SVG;
